// @mui
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// routes
// locales
import { useLocales } from 'src/locales';
import { LoggedInUser } from 'src/types/user';
import Label from 'src/components/label';
import Button from '@mui/material/Button';
import { paths } from 'src/routes/paths';
import { PopupWidget } from "react-calendly";
import { useTheme, alpha } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';

// components

// ----------------------------------------------------------------------

export default function NavUpgrade() {
  const mockedUser = useMockedUser();
  const user = mockedUser.user as LoggedInUser;
  const navigate = useNavigate();

  const { t } = useLocales();
  const shouldShowPricingView = () => {
    if (!user || !user.expiryDate ) return false;
    if(user.purchase===1) return false;
    if(user.expiryDate!=="NO") return true;


    return false;
  };

  const rootElement = document.getElementById("root");
  const theme = useTheme();

  // Derive tenant logo similar to header/account popover
  const tenantSlug = String(user?.tenant || 'nattygains').toLowerCase();
  const headerHost = (() => {
    const raw = (user as any)?.url || '';
    if (!raw) return '';
    try {
      const withProto = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
      return new URL(withProto).origin;
    } catch {
      return '';
    }
  })();
  const tenantLogoSrc = headerHost
    ? `${headerHost}/public/img/logo/${tenantSlug}.png`
    : `/static/img/logo/${tenantSlug}.png`;


  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Box
          sx={{
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.32)}`,
            borderRadius: '50%',
            transition: (theme) => theme.transitions.create(['border-color'], { duration: theme.transitions.duration.shortest }),
            '&:hover': { borderColor: 'primary.main' },
          }}
        >
          <Avatar
            src={tenantLogoSrc}
            alt={user?.tenant || user?.name}
            onClick={() => navigate(paths.dashboard.user.account)}
            imgProps={{
              onError: (e: any) => {
                (e.currentTarget as HTMLImageElement).src = '/logo/logo_single.png';
              },
              referrerPolicy: 'no-referrer',
            }}
            sx={{ width: 48, height: 48, cursor: 'pointer', border: (theme) => `solid 2px ${theme.palette.primary.main}`, bgcolor: 'background.default' }}
          />
          {shouldShowPricingView()? <Label
            color="success"
            variant="filled"
            sx={{
              top: -6,
              px: 0.5,
              left: 40,
              height: 20,
              position: 'absolute',
              borderBottomLeftRadius: 2,
            }}
          >
            Free
          </Label>:null }
        </Box>

        <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.name || user?.email}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
            {user?.email}
          </Typography>
        </Stack>

        {shouldShowPricingView()? <Button variant="contained"
                                          onClick={() => navigate('/pricing')}
                                          >
          {t('upgrade_to_pro')}
        </Button> :null}


      </Stack>

    </Stack>
  );
}
